/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Compare_Links_ProInputs */

const en_landing_pricing_compare_links_pro = /** @type {(inputs: Landing_Pricing_Compare_Links_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dofollow`)
};

const zh_landing_pricing_compare_links_pro = /** @type {(inputs: Landing_Pricing_Compare_Links_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dofollow`)
};

/**
* | output |
* | --- |
* | "Dofollow" |
*
* @param {Landing_Pricing_Compare_Links_ProInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_compare_links_pro = /** @type {((inputs?: Landing_Pricing_Compare_Links_ProInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Compare_Links_ProInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_compare_links_pro(inputs)
	return zh_landing_pricing_compare_links_pro(inputs)
});
export { landing_pricing_compare_links_pro as "landing.pricing.compare_links_pro" }